import { VStack } from "@chakra-ui/react";

import Img from "./Img";
import Txt from "./Txt";


export default function HeroImage() {
  return (
    <VStack w="100%" h="45%" flex={1} spacing={0}>
      <Txt />
      <Img />
    </VStack>
  );
}
